import { render, staticRenderFns } from "./DeclareList.vue?vue&type=template&id=3a86f84e&scoped=true&"
import script from "./DeclareList.vue?vue&type=script&lang=js&"
export * from "./DeclareList.vue?vue&type=script&lang=js&"
import style0 from "./DeclareList.vue?vue&type=style&index=0&id=3a86f84e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a86f84e",
  null
  
)

export default component.exports